module.exports = __webpack_public_path__ + "img/azoresislands.c5c626f8.svg";